import { currencySymbol } from '../lib/format';

interface CurrencySelectorProps {
  // Só as moedas que realmente têm venda registrada (ver byCurrency nas
  // respostas do Worker) — nunca a lista inteira de moedas ISO possíveis.
  currencies: string[];
  value: string;
  onChange: (currency: string) => void;
}

// Só aparece quando existe mais de uma moeda com venda no período — com
// uma moeda só a seleção já é automática (ver InfluencerDashboardPage.tsx/
// AdminDashboardPage.tsx) e um seletor de opção única seria só ruído
// visual (pedido explícito do proprietário: "sem ocupar espaço
// excessivo").
export function CurrencySelector({ currencies, value, onChange }: CurrencySelectorProps) {
  if (currencies.length <= 1) return null;

  return (
    <select
      className="input w-auto !py-1.5 text-sm"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      aria-label="Moeda"
    >
      {currencies.map((currency) => (
        <option key={currency} value={currency}>
          {currencySymbol(currency)} {currency}
        </option>
      ))}
    </select>
  );
}
